export default {"src":"/_next/static/media/us.2d0a1dd6.svg","height":480,"width":640};